import { antiFraudConstants } from '../constants/anti-fraud.constants'
import getHash from '../helpers/hash-generator.helper'

const generateSessionID = () => dispatch => {
	dispatch({
		type: antiFraudConstants.GENERATE_SESSION_ID,
		payload: getHash()
	})
}

export const antiFraudActions = {
	generateSessionID
}
